
<script>

    import { _ } from "svelte-i18n";
    import { onMount , onDestroy } from 'svelte';
    import { push} from 'svelte-spa-router'
    import fetchData from '../api_crm.js';


    let socket;
    let message = '';
    let messages = [];

    onDestroy(() => {
        // Close the WebSocket connection when the component is destroyed
        if (socket) {
            socket.close();
        }
    });

    // Function to send a message
    const sendMessage = () => {
        if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(message);
            message = ''; // Clear the input after sending
        }
    };











    let customers_count = 0,
        door_count = 0,
        pickup_count = 0,
        voipActive = false,
        voipConnected = false,
        voipData = {}

    $: shipments_count = door_count + pickup_count;


    onMount(async() => {


        console.log('on mount webs socket before start');

        // Create a WebSocket connection
        let ip = 'wss://crm.gurus.co.il:8082';
        socket = new WebSocket(ip);

        // Handle connection open
        socket.onopen = () => {
            console.log('WebSocket connection opened');
            voipConnected = true;
        };

        // Handle incoming messages
        socket.onmessage = (event) => {
            let data = JSON.parse(event.data);
            console.log('Message from server:', data);
            // Add the received message to the messages array
            messages.push(event.data);

            let closed = data?.closed || null;

            voipData = {};
            
            if (closed!=null) {

                voipActive = false;

            } else {

                voipActive = true;
                let item = {};


                for(var index in data) {

                    item = data[index]

                    if (typeof item?.CustomerName?.value === 'string' && item?.CustomerName?.value?.trim() !='' ) {
                        voipData.name = item.CustomerName?.value;
                    }
                    if (typeof item?.Tel1?.value === 'string' && item?.Tel1?.value?.trim()!='') {
                        voipData.number = item.Tel1.value
                    }
                    if (typeof item?.CellPhone?.value === 'string' && item?.CellPhone?.value?.trim()!='') {
                        voipData.number = item.CellPhone.value
                    }
                    if (typeof item?.id?.value !== 'undefined' ) {
                        voipData.id = item?.id?.value;
                    }

                }

            }
            
        };

        // Handle connection close
        socket.onclose = function (event) {
            if (event.wasClean) {
                console.log("Connection closed cleanly.");
            } else {
                console.error("Connection interrupted:", event);
            }
            console.log("Code:", event.code, "Reason:", event.reason);
            voipConnected = false;
        };

        // Handle errors
        socket.onerror = (error) => {
            console.error('WebSocket error observed:', error);
            voipConnected = false;
        };

        // const ctx = document.getElementById('myChart');

        // const data = {
        //     datasets: [
        //         {
        //             label: '',
        //             data: [
        //                     {
        //                         x: 0,
        //                         y: 1
        //                     }, 
        //                     {
        //                         x: 1,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 2,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 3,
        //                         y: 4
        //                     }, 
        //                     {
        //                         x: 4,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 5,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 6,
        //                         y: 1
        //                     }, 
        //                     {
        //                         x: 7,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 8,
        //                         y: 3
        //                     },
        //                     {
        //                         x: 9,
        //                         y: 4
        //                     }, 
        //                     {
        //                         x: 10,
        //                         y: 2
        //                     }, 
        //                     {
        //                         x: 11,
        //                         y: 3
        //                     }
        //             ],
        //             backgroundColor: '#ca171e',
        //             borderColor: '#ca171e',
        //             color: '#ca171e',
        //             hoverBorderWidth:2
        //         }
        //     ],
        // };

        // const config = {
        //     type: 'bubble',
        //     data: data,
        //     options: {
        //         animations: {
        //             tension: {
        //                 duration: 1000,
        //                 easing: 'linear',
        //                 from: 1,
        //                 to: 0,
        //                 loop: true
        //             }
        //         },
        //         layout: {
        //             padding: 1
        //         },
        //         responsive: true,
        //         plugins: {
        //             tooltip : {
        //                 enabled : false
        //             },
        //             legend: {
        //                 position: 'top',
        //                 display: false,
        //             },
        //             title: {
        //                 display: false,
        //                 text: 'Chart.js Scatter Chart'
        //             }
        //         }
        //     },
        // };

        // new Chart(ctx, config);

    });
    
    // setInterval(async() => {

    //     return;

    //     let postData = {
    //         voip : 1,
    //         action : 'index',
    //         //time : '10 SECOND'
    //     }

    //     let obj = await fetchData(postData);
    //     if (obj.data && obj.data.length > 0) {
    //         const voipNumber = obj.data[0].number;
    //         const storedVoip = localStorage.getItem('voip');

    //         // If the voip number is not already in local storage
    //         if (!storedVoip || storedVoip !== voipNumber) {
    //             // Save the new voip number to local storage
    //             localStorage.setItem('voip', voipNumber);

    //             voipActive = true;

    //             voipData.name = obj.data[0].name
    //             voipData.number = obj.data[0].number
    //             voipData.id = obj.data[0].id

                     
    //         }
    //     }

    // }, 10000);

</script>
<div class="dash-top crm">
    <div class="dash-top-cell">
        <div>
            <div class="profile-image">
                <img src="{siteUrl}images/yehuda.jpg">
            </div> 
        </div>
        {#if voipActive}
        <div class="dash-top-call">
            <i class="fa-solid fa-headset"></i>
            <span>שיחה נכנסת מ-</span> 
            {#if voipData.name!=''}
            <strong>{voipData.name}</strong>
            {/if}
            <span>{voipData.number}
            {#if voipData.id && voipData.id > 0 }
            <span class="button" on:click={()=> { push('/objects/1/' + voipData.id) } }>מעבר לכרטיס לקוח</span>
            {/if}
        </div>
        {:else}
        <div class="dash-top-call">
            <i class="fa-solid fa-headset"></i>
            {#if voipConnected}
            <span class="green-tele">מחובר למערכת טלופוניה</span> 
            {:else}
            <span class="black-tele">מנותק למערכת טלופוניה</span> 
            {/if}
        </div>
        {/if}
    </div>
    <div class="dash-top-cell">
        
    </div>
</div>
<div class="dash-top">
    <div class="box">
        <div><i class="fa-solid fa-chart-simple"></i> {$_('dash.statics')}</div>
    </div>
    <div class="box">
        <div>{$_('dash.shipments')}</div>
        <div>{shipments_count}</div>
        <!-- <div class="canvas-container">
            <canvas id="myChart"></canvas>
        </div> -->
    </div>
    <div class="box">
        <div>{$_('dash.returns')}</div>
        <div>{customers_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
    <div class="box">
        <div>{$_('dash.door')}</div>
        <div>{door_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
    <div class="box">
        <div>{$_('dash.pickup')}</div>
        <div>{pickup_count}</div>
        <!--<canvas id="myChart"></canvas>-->
    </div>
</div>
<style>
    .green-tele {
        background: #2c9400;
        border-radius: 4px;
        padding: 3px 10px;
        color: white;
        margin: 0 10px;
    }
    .black-tele {
        background: #000;
        border-radius: 4px;
        padding: 3px 10px;
        color: white;
        margin: 0 10px;
    }
    .canvas-container {
        width: 200px;;
        height: 70px;
    }
    .dash-top{
        display: none;
        gap:20px;
        justify-content: space-between;
        box-shadow: rgba(17, 43, 85, 0.1) 0px 12px 28px 0px;
        background-color: #fff;;
        
    }
    .dash-top .box{
        border-radius: 7px;
        padding:10px 20px;
        width: 200px;
        text-align: center;
        background-color: #fff;;
        font-size:15px;      
        display: flex;
        gap:10px;  
    }


    .dash-top.crm {   
        display: flex;
        flex-direction: row-reverse;   
        position:fixed;  
        width: 100%;
        left:0;
        justify-content: end;
        align-items: center;
        gap:5px;
        z-index: 2;
    }
    .dash-top-cell {
        display: flex;
        flex-direction: row-reverse;   
        justify-content: end;
        align-items: center;
        gap:5px
    }

    .profile-image {
        margin:5px 10px;
        border-radius:50%;
        width: 40px;
        height: 40px;;
        border:3px solid #ca171e;
    }
    .profile-image img{
        border:4px solid #fff;
        width:100%;
        border-radius:50%;
        box-sizing: border-box;    
    }
    .dash-top-call {
        border-left: 1px solid #e4e4e4;
        height: 100%;
        box-sizing: border-box;
        padding: 16px;
        font-size: 14px;;
    }
    .dash-top-call i {
        color: #ca171e;
        font-size:17px;
    }
    .dash-top-call .button {
        margin-right:10px;
    }
</style>